var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top",style:({backgroundImage: 'url(' + _vm.getImgSrc + ')'})},[_c('span',{staticClass:"fontExtraBold textWhite font34 marginAutoAll"},[_vm._v(" "+_vm._s(_vm.subTitle.sub_title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }